import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GridActionsCellItem } from '@mui/x-data-grid';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { listCodes } from '../../modules/comCode';
import client from '../../lib/api/client';
import CodeList from '../../components/codemng/CodeList';
import AskRemoveDialog from '../../components/codemng/AskRemoveDialog';


import * as yup from 'yup';
import { useFormik } from 'formik';
import { CodeListBox } from '../../components/codemng/CodeListBox';

const CodeListContainer = ({ editFunction, handleAdd }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [searchKeyword, setSearchKeyword] = useState("revVal2");
  const [searchWords, setSearchWords] = useState(null);

  const [removeId, setRemoveId] = useState(null);

  const { comCodes, error, loading } = useSelector(({ comCode, loading }) => ({
    comCodes: comCode.comCodes,
    error: comCode.listError,
    loading: loading['comCode/LIST_CODES'],
  }));


  useEffect(() => {
    if (searchKeyword !== '' && searchWords !== '') {
      searchList(formik?.values);
    }
  }, []);


  const searchList = (values) => {
    let searchData = {
      [values.searchKeyword]: values.searchWords,

    };


    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);

    dispatch(listCodes(searchData));

  }

  const initialValues = {
    searchKeyword: searchKeyword,
    searchWords: searchWords,
  };


  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });


  const [visible, setVisible] = useState(false);

  const onCancle = () => {
    setVisible(false);
    setRemoveId(null);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  const onRemove = () => {
    client
      .delete(`/api/v1/common/info/${removeId}`)
      .then((res) => {
        if (res.data) {
          enqueueSnackbar('삭제 성공', {
            variant: 'success',
          });
          searchList(formik.values);
        }
      })
      .catch((err) => {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      });
    setRemoveId(null);
  };

  const deleteCode = useCallback(
    (id) => () => {
      setVisible(true);
      setRemoveId(id);
    },
    [],
  );

  const editCode = useCallback(
    (params) => () => {
      editFunction(params.row);
    },
    [],
  );

  const columns = useMemo(
    () => [
      { field: 'id', hide: true, identity: true },
      { field: 'blcCd', headerName: '대분류', minWidth: 150, type: 'string' },
      { field: 'mlcCd', headerName: '중분류', minWidth: 150, type: 'string' },
      { field: 'slcCd', headerName: '소분류', minWidth: 150, type: 'string' },
      { field: 'itemNm', headerName: '코드명', minWidth: 200, type: 'string' },
      { field: 'revVal1', headerName: '값1', type: 'string' },
      { field: 'revVal2', headerName: '값2', type: 'string' },
      { field: 'step', headerName: '정렬순서', type: 'number' },
      { field: 'useYn', headerName: '사용유무', type: 'boolean' },
      {
        field: 'itemDesc',
        headerName: '코드설명',
        minWidth: 300,
        type: 'string',
      },
      {
        field: 'cngNm',
        headerName: '수정자',
        description: '등록/수정자',
        type: 'string',
      },
      {
        field: 'cngTm',
        headerName: '수정일',
        description: '등록/수정일',
        minWidth: 200,
        type: 'string',
      },

      {
        field: 'actions',
        type: 'actions',
        width: 80,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            onClick={editCode(params)}
          //showInMenu
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={deleteCode(params.id)}
          />,
        ],
      },
    ],
    [deleteCode, editCode],
  );

  return (
    <div>
      <CodeListBox formik={formik} handleAdd={handleAdd} />
      <CodeList
        columns={columns}
        loading={loading}
        comCodes={comCodes}
        error={error}
        editFunction={editFunction}
        
        columnVisibilityModel={{
          id: false,
        }}
      />
      <AskRemoveDialog
        visible={visible}
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </div>
  );
};

export default CodeListContainer;
